<template>
	<div class="order-header">
		<div>{{$t('other.a908')}}</div>
		<div >
			<el-tabs v-model="this.$route.path" @tab-click="handleClick">
			   <el-tab-pane 
			   v-for="item in tabs"
			   :key="item.name"
			   :label="item.label"
			   :name="item.name"
			   >
			   </el-tab-pane>
				   <router-view></router-view>
			</el-tabs>	
			
		</div>
		
		
	</div>
</template>

<script>

	export default{
		data(){
			return {
				// activeName: "/orders/shopee",
				tabs: [
				  { label: "shopee", name: "/processed/processedshopee",},
				  { label: "lazada", name: "/processed/processedlazada",},
				],
			}
		},
		
		methods: {
			
			handleClick(tab, event,name) {
			    // console.log(tab, event);
			  this.$router.replace(tab.name);
			  this.activeName = tab.name;
			  console.log(this.activeName)
			  console.log(this.$route.path)
			},
		}
		
	}
</script>

<style>
	
	/* .order-header{
		flex: 1;
		margin: 60px 0 0 235px;
	} */
	
</style>
